import type { PaginationState } from "@tanstack/react-table";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

export interface BridgeScannerStoreType {
  assetTxSwitch: boolean;
  setAssetTxSwitch: (value: boolean) => void;
  liveMode: boolean;
  setLiveMode: (value: boolean) => void;
  isControlWindowOpen: boolean;
  setControlWindowOpen: (value: boolean) => void;
  activePaginatedPage: PaginationState;
  setActivePaginatedPage: (value: PaginationState) => void;
  address: string;
  setAddress: (value: string) => void;
}

export const useBridgeScannerStore = create<BridgeScannerStoreType>()(
  immer((set) => ({
    assetTxSwitch: false,
    setAssetTxSwitch: (value) => set({ assetTxSwitch: value }),
    liveMode: false,
    setLiveMode: (value) => set({ liveMode: value }),
    isControlWindowOpen: false,
    setControlWindowOpen: (value) => set({ isControlWindowOpen: value }),
    activePaginatedPage: {
      pageIndex: 0,
      pageSize: 10,
    },
    setActivePaginatedPage: (value) => set({ activePaginatedPage: value }),
    address: "",
    setAddress: (value) => set({ address: value }),
  })),
);
